module.exports = __webpack_public_path__ + "img/deviceUnknown.31cd266f.svg";